import { Button } from '@calendly/ui/components/button'
import { MinimalButton } from '@calendly/ui/components/minimal-button'
import classNames from 'classnames'
import { useMemo } from 'react'

const FilterListAction = ({ isDisabled = false, title = '', isPressed, children, onClick, decoration = 'secondary-outline' }) => {
  const className = useMemo(() => classNames(
    'filter-list-action',
    isPressed ? 'is-pressed' : undefined,
  ), [isPressed])

  const buttonClassName = useMemo(() => classNames(
    'filter-list-action-button',
    { 'is-disabled': isDisabled },
  ), [isDisabled])

  const handleClick = () => (isDisabled ? null : onClick())
  const Component = decoration === 'minimal' ? MinimalButton : Button

  return (
    <div className={className}>
      <Component
        title={title}
        className={buttonClassName}
        onClick={handleClick}
        aria-disabled={isDisabled}
        size="small"
        decoration={decoration === 'minimal' ? undefined : decoration}
      >
        {children}
      </Component>
    </div>
  )
}

export default FilterListAction
